import axios from './index.js'

//返回二维码图片流(微信)
export let postWxpayUnifiedUrl = (params) => {
    // let data = new FormData();
    // data.append('total_price', params.total * 100);
    // data.append('order_num', params.orderNum);
    return axios.post(`/order/pay`, params);
};

//返回二维码图片流(支付宝)
export let postAlipayUnifiedUrl = (params) => {
    // let data = new FormData();
    // data.append('total_price', params.total);
    // data.append('order_num', params.orderNum);
    return axios.post(`/order/pay`, params);
};

//返回二维码form(支付宝)
export let postAlipayUnifiedUrlNet = (params) => {
    return axios.post(`/net/order/pay`, params);
};

//返回二维码form(支付宝)
export let postAlipayUnifiedUrlWm = (params) => {
    return axios.post(`/order/pay`, params);
};

//通过订单编号校验支付状态
export let getOrderCheckOld = (params) => {
    let t = new Date().getTime();
    return axios.get(`/order/check/${params}?t=` + t)
};

//获取订单详情
export let getOrderCheck = (params) => {
    let t = new Date().getTime();
    return axios.get(`/order?orderId=${params}&t=` + t)
};

//创建订单(舞美)   id  1:免费  2:有金额
export let postWMOrder = (params) => {
    return axios.post(`/order`, params)
};

//获取订单详情(舞美)
export let getWMOrder = (params) => {
    return axios.get(`/order?orderId=${params}`)
};

//测试支付
export let getPayTest = (params) => {
    return axios.post(`/order/payTest/${params}`)
};

//创建企业订单(舞美企业)
export let postOrderCreateEntOrder = (params) => {
    return axios.post(`/order/createEntOrder`, params);
};

//创建订单(网络表演)
export let postNetOrder = (params) => {
    return axios.post(`/net/order`, params)
};

//测试支付(网络表演)
export let getNetPayTest = (params) => {
    return axios.post(`/net/order/payTest/${params}`)
};

//获取订单详情(网络表演)
export let getNetOrder = (params) => {
    return axios.get(`/net/order?orderId=${params}`)
};

//返回二维码图片流(微信) 网络表演
export let postNetWxpayUnifiedUrl = (params) => {
    return axios.post(`/net/order/pay`, params);
};

//通过订单编号校验支付状态 网络表演
export let getNetOrderCheck = (params) => {
    let t = new Date().getTime();
    return axios.get(`/net/order?orderId=${params}&t=` + t)
};



// WEBPACK FOOTER //
// ./src/api/pay.js